// extracted by mini-css-extract-plugin
export default {"zonesButtons":"ButtonsAddDelete_zonesButtons__-Ar5V"};